import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { AttachmentsService } from './attachments.service';
import { BaseService } from './base-service';
import { CreateGlobalConfiguration$Params } from '@api/backend-connector/fn/global-configurations/create-global-configuration';
import { DeleteGlobalConfiguration$Params } from '@api/backend-connector/fn/global-configurations/delete-global-configuration';
import { GetGlobalConfiguration$Params } from '@api/backend-connector/fn/global-configurations/get-global-configuration';
import { ListGlobalConfigurations$Params } from '@api/backend-connector/fn/global-configurations/list-global-configurations';
import { UpdateGlobalConfigurationRequest } from '@api/backend-connector/models';
import { GlobalConfigurationsApi } from '@api/backend-connector/services';

const toasts = {
  createSuccessSummary: 'i18n.GlobalConfigurationToast.createSuccessSummary',
  createSuccessDetail: 'i18n.GlobalConfigurationToast.createSuccessDetail',
  createFailSummary: 'i18n.GlobalConfigurationToast.createFailSummary',
  createFailDetail: 'i18n.GlobalConfigurationToast.createFailDetail',

  updateSuccessSummary: 'i18n.Toast.updateSuccessSummary',
  updateSuccessDetail: 'i18n.Toast.updateSuccessDetail',
  updateFailSummary: 'i18n.Toast.updateFailSummary',
  updateFailDetail: 'i18n.Toast.updateFailDetail',

  deleteSuccessSummary: 'i18n.GlobalConfigurationToast.deleteSuccessSummary',
  deleteSuccessDetail: 'i18n.GlobalConfigurationToast.deleteSuccessDetail',
  deleteFailSummary: 'i18n.GlobalConfigurationToast.deleteFailSummary',
  deleteFailDetail: 'i18n.GlobalConfigurationToast.deleteFailDetail',
};

@Injectable({
  providedIn: 'root',
})
export class GlobalConfigurationsService extends BaseService {
  private readonly attachmentsService = inject(AttachmentsService);
  override toasts = toasts;

  readonly refresh$ = new BehaviorSubject<void>(undefined);

  private readonly globalConfigurationApi = inject(GlobalConfigurationsApi);

  getGlobalConfiguration(params: GetGlobalConfiguration$Params) {
    return this.globalConfigurationApi.getGlobalConfiguration(params);
  }

  listGlobalConfiguration(params: ListGlobalConfigurations$Params) {
    return this.globalConfigurationApi.listGlobalConfigurations(params);
  }

  createGlobalConfiguration(params: CreateGlobalConfiguration$Params) {
    return this.globalConfigurationApi.createGlobalConfiguration(params);
  }

  updateGlobalConfiguration(id: string, request: UpdateGlobalConfigurationRequest) {
    return this.globalConfigurationApi.updateGlobalConfiguration({ id, body: request });
  }

  deleteGlobalConfiguration(params: DeleteGlobalConfiguration$Params) {
    return this.globalConfigurationApi.deleteGlobalConfiguration(params);
  }
}
